<template>
    <Component :is="display" :manufacturer="manufacturer" :index="index" :individual="individual" />
</template>

<script setup>
import { computed } from "vue";
import SourcingCard from "../../../Themes/Sourcing/Components/Modules/Cards/PriceBookCard.vue";
import MarketingCard from "../../../Themes/Marketing/Components/Modules/Cards/PriceBookCard.vue";
import { useUser } from "@/Composables";

const { settings } = useUser();
const display = computed(() =>
    settings.value.is_sourcing_mode ? SourcingCard : MarketingCard
);

defineProps(["manufacturer", "index", "individual"]);
</script>
